module.exports = __webpack_public_path__ + "static/media/aimSight.9cb9843f.svg";